/* eslint-disable prefer-destructuring */
import styled from 'styled-components'

import customTheme from '../../../utils/theme'

const dropdownPaddingY = customTheme.dropdown.dropdownPaddingY
const dropdownSpacer = customTheme.dropdown.dropdownSpacer
const dropdownDividerBg = customTheme.dropdown.dropdownDividerBg
const dropdownItemPaddingX = customTheme.dropdown.dropdownItemPaddingX
const dropdownItemPaddingY = customTheme.dropdown.dropdownItemPaddingY
const dropdownLinkColor = customTheme.dropdown.dropdownLinkColor
const dropdownLinkDisabledColor = customTheme.dropdown.dropdownLinkDisabledColor
const fontSizeSm = customTheme.typography.fontSizeSm
const dropdownHeaderColor = customTheme.dropdown.dropdownHeaderColor

const navbarFontSize = customTheme.typography.fontSizeSm
const navbarFontWeight = customTheme.typography.fontWeightNormal
const navDropdownPaddingY = customTheme.navBar.navDropdownPaddingY
const navDropdownPaddingX = customTheme.navBar.navDropdownPaddingX
const textColor = customTheme.dropdown.dropdownTextColor

const DropdownWrapper = styled.div`
  display: inline-block;
  .dropup,
  .dropright,
  .dropdown,
  .dropleft {
    position: relative;
  }

  .dropdown-toggle {
    /* Generate the caret automatically */
    @include caret;
  }

  /* The dropdown menu */
  .dropdown-menu {
    font-size: ${fontSizeSm};
    padding: ${navDropdownPaddingY} ${navDropdownPaddingX};
    border: none;
    border-radius: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    z-index: 9;
    &:empty {
      display: none;
    }
    .dropdown-item {
      outline: none;
      position: relative;
      font-size: ${navbarFontSize};
      font-weight: ${navbarFontWeight};
      color: ${textColor};
      text-decoration: none;
    }
    &:after,
    &:before {
      position: absolute;
      content: '';
      height: 0;
      width: 0;
      border: solid transparent;
      pointer-events: none;
      bottom: 100%;
      left: 20%;
    }
    &:after {
      border-bottom-color: white;
      border-width: 10px;
    }
    &:before {
      border-bottom-color: grey;
      border-width: 10px;
    }
  }

  /* Allow for dropdowns to go bottom up (aka, dropup-menu)
  Just add .dropup after the standard .dropdown class and you're set. */
  .dropup {
    .dropdown-menu {
      top: auto;
      bottom: 100%;
      margin-top: 0;
      margin-bottom: ${dropdownSpacer};
    }

    .dropdown-toggle {
      @include caret(up);
    }
  }

  .dropright {
    .dropdown-menu {
      top: 0;
      right: auto;
      left: 100%;
      margin-top: 0;
      margin-left: ${dropdownSpacer};
    }

    .dropdown-toggle {
      @include caret(right);
      &::after {
        vertical-align: 0;
      }
    }
  }

  .dropleft {
    .dropdown-menu {
      top: 0;
      right: 100%;
      left: auto;
      margin-top: 0;
      margin-right: ${dropdownSpacer};
    }

    .dropdown-toggle {
      @include caret(left);
      &::before {
        vertical-align: 0;
      }
    }
  }

  /* When enabled Popper.js, reset basic dropdown position
  stylelint-disable no-duplicate-selectors */
  .dropdown-menu {
    &[x-placement^='top'],
    &[x-placement^='right'],
    &[x-placement^='bottom'],
    &[x-placement^='left'] {
      right: auto;
      bottom: auto;
    }
  }

  /* stylelint-enable no-duplicate-selectors
  Divider within the dropdown */
  .dropdown-divider {
    @include nav-divider(${dropdownDividerBg});
  }

  /* Links, buttons, and more within the dropdown menu */

  &.disabled,
  &:disabled {
    color: ${dropdownLinkDisabledColor};
    background-color: transparent;
    /* Remove CSS gradients if they're enabled */
    @if $enable-gradients {
      background-image: none;
    }
  }

  .dropdown-menu.show {
    display: block;
  }

  /* Dropdown section headers */
  .dropdown-header {
    display: block;
    padding: ${dropdownPaddingY} ${dropdownItemPaddingX};
    margin-bottom: 0;
    font-size: ${fontSizeSm};
    color: ${dropdownHeaderColor};
    white-space: nowrap;
  }

  /* Dropdown text */
  .dropdown-item-text {
    display: block;
    padding: ${dropdownItemPaddingY} ${dropdownItemPaddingX};
    color: ${dropdownLinkColor};
  }
`

export default DropdownWrapper
